import script from "./MenuSelectedPatient.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuSelectedPatient.vue?vue&type=script&setup=true&lang=js"

import "./MenuSelectedPatient.vue?vue&type=style&index=0&id=265afd91&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-265afd91"]])

export default __exports__